module.exports = __webpack_public_path__ + "img/right.4789e871.png";